import * as React from 'react';
import {type PluginsType} from './PluginsType';

const PluginsNotProvided: PluginsType = new Proxy(
  {},
  {
    get() {
      throw new Error(
        'Plugin-consuming components must be nested in a Plugins.RuntimeContext.Provider!'
      );
    },
  }
) as PluginsType;

export const RuntimeContext =
  React.createContext<PluginsType>(PluginsNotProvided);
